





















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { StudentSubjectRow } from "../../modules/student/HomeworkSheetList"


export interface Data {
  studentSubjectRows: StudentSubjectRow[]
  maxReportCount: number
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const StudentSheetStatusEnum = Common.StudentSheetStatusEnum;
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      studentSubjectRows: [],
      maxReportCount: 10,
      errors: [],
    });

    /******************************
     * 日時を画面表示文言にコンバート
     ******************************/

    const convertDateString = (date: string) => {
      return date ? moment(date).format('MM月DD日HH時mm分') : "-";
    };

    /******************************
     * 解答画面へ遷移
     ******************************/

    const answerStart = (sheet_id: number) => {
      if(context.root.$store.getters.isAdmin){
        context.root.$router.push(`/teacher_site/answer_input/${sheet_id}`).catch(err => {});
      }else{
        context.root.$router.push(`/${context.root.$store.state.currentUser.school_id}/student_site/answer_input/${sheet_id}`).catch(err => {});
      }
    }

    /******************************
     * 採点結果表示画面へ
     ******************************/

    const toResultImagePreview = async (sheet: any) => {
      if(context.root.$store.state.currentUser.role == Common.RoleEnum.Student){
        context.root.$router.push(`/${context.root.$store.state.currentUser.school_id}/student_site/result_image_preview/${sheet.id}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/result_image_preview/${sheet.id}`).catch(err => {});
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      
      await http.get(`/api/student/homework_sheet_list?student_no_character=${context.root.$store.state.student_no_character}`).then(response => {
        state.studentSubjectRows = response.data.student_subject_rows.map((x: any) => new StudentSubjectRow(x));
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      StudentSheetStatusEnum,
      convertDateString,
      answerStart,
      toResultImagePreview,
    }
  }
});
